import { useCallback } from "react";
import { RootState, useAppSelector } from "../../framework/customStore";

export const useSelectSelectedPlannedWorkShift = () => {
    const selectedShiftId = useAppSelector(
        (state) => state.workShiftPlanning.sidebar.plannedShiftId
    );

    const shiftSelector = useCallback(
        (state: RootState) =>
            state.workShiftPlanning.plannedWorkShifts.find(
                (s) => s.id === selectedShiftId
            ),
        [selectedShiftId]
    );

    return useAppSelector(shiftSelector);
};
